@let isTopCardValue = isTopCard();
@let ampelDataValue = ampelData();
@let ampelColorValue = ampelColor();
<ng-template #topCardsDashboardAmpel>
  @if (isTopCardValue && ampelDataValue) {
    <mat-card
      appearance="outlined"
      class="ampel-card"
      [tp]="ampelInfo"
      variation="popper"
      trigger="mouseenter"
      tpPlacement="bottom"
      [tpIsLazy]="true">
      @if (ampelDataValue['writtenAt']) {
        <div class="dashboard-updated-chip">
          <fa-icon [icon]="['far', 'clock']"></fa-icon>
          {{
            ampelDataValue['writtenAt']
              | datex: 'DD.MM. HH:mm' : undefined : languageService.langSignal()
          }}
        </div>
      }
      <p>{{ 'PRODUCT.AMPEL.TITLE' | translate }}</p>
      <h1>
        <fa-icon [icon]="[icons.GREEN, 'circle']" class="ampel-GREEN"></fa-icon>
        <fa-icon
          [icon]="[icons.YELLOW, 'circle']"
          class="ampel-YELLOW"></fa-icon>
        <fa-icon [icon]="[icons.RED, 'circle']" class="ampel-RED"></fa-icon>
      </h1>
    </mat-card>
  }
</ng-template>

<ng-template #ampelInfo class="ampel-card">
  @if (ampelDataValue['writtenAt']) {
    <div class="dashboard-updated-chip">
      <fa-icon [icon]="['far', 'clock']"></fa-icon>
      {{
        ampelDataValue['writtenAt']
          | datex: 'DD.MM. HH:mm' : undefined : languageService.langSignal()
      }}
    </div>
  }
  @for (line of ampelDataValue['text'].split('\n'); track $index) {
    <div>
      {{ line }}
    </div>
  }
</ng-template>

@if (!isTopCardValue && ampelDataValue) {
  @if (!isLoading()) {
    <div class="ampel-content">
      <div class="ampel-container">
        <div class="ampel-visual">
          <div class="ampel-traffic-light">
            @for (color of ['RED', 'YELLOW', 'GREEN']; track $index) {
              <div
                class="ampel-row"
                [class.is-active]="color === ampelColorValue">
                <!-- Text-Label über/neben dem Licht -->
                <span class="ampel-label" [ngClass]="'text-' + color">
                  {{ 'PRODUCT.AMPEL.' + color | translate }}
                </span>
                <div
                  class="ampel-bulb"
                  [ngClass]="[
                    'bulb-' + color,
                    color === ampelColorValue ? 'bulb-active' : 'bulb-inactive',
                  ]">
                  <fa-icon
                    [icon]="[
                      'far',
                      color === ampelColorValue ? 'check' : 'minus',
                    ]"
                    class="ampel-icon">
                  </fa-icon>
                </div>
              </div>
            }
          </div>
        </div>
        <div class="ampel-details" [ngClass]="'status-' + ampelColorValue">
          <div class="ampel-header">
            <span
              class="status-badge"
              [ngClass]="'badge-' + ampelColorValue"></span>
            <h2>{{ 'PRODUCT.AMPEL.' + ampelColorValue | translate }}</h2>
          </div>

          <div class="ampel-body">
            @for (line of ampelDataValue['text'].split('\n'); track $index) {
              <p class="ampel-text">{{ line }}</p>
            }
          </div>
        </div>
      </div>
    </div>
  } @else {
    <app-loading-overlay text="Daten werden geladen..." [fullScreen]="false">
    </app-loading-overlay>
  }
}
